import { render, staticRenderFns } from "./software-market-nav.vue?vue&type=template&id=ab7fac0e&scoped=true"
import script from "./software-market-nav.vue?vue&type=script&lang=js"
export * from "./software-market-nav.vue?vue&type=script&lang=js"
import style0 from "./software-market-nav.vue?vue&type=style&index=0&id=ab7fac0e&prod&lang=scss"
import style1 from "./software-market-nav.vue?vue&type=style&index=1&id=ab7fac0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7fac0e",
  null
  
)

export default component.exports